import React from 'react';
import { Box, Text } from '@chakra-ui/react';

/**
 * Shimmer component for "thinking" animation
 * Shows animated text while the AI is processing
 */
const ShimmerThinking = () => {
  return (
    <Box
      mb={6}
      pl={4}
      pr={2}
    >
      <Text
        fontSize="sm"
        color="blue.400"
        fontWeight="medium"
        display="inline-block"
        position="relative"
        background="linear-gradient(90deg, #4169E1 0%, #87CEEB 50%, #4169E1 100%)"
        backgroundSize="200% 100%"
        animation="shimmer 2s ease-in-out infinite"
        sx={{
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          '@keyframes shimmer': {
            '0%': {
              backgroundPosition: '200% center',
            },
            '100%': {
              backgroundPosition: '-200% center',
            },
          },
        }}
      >
        Thinking...
      </Text>
    </Box>
  );
};

export default ShimmerThinking;

